import { PopUpOpenPage } from './PopUpOpenPage';

export type { TypePopUpOpenPageProps } from './types';
export default PopUpOpenPage;
